import React from 'react';
import {action, observable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import {Button, Form, Icon, Input, message, Modal} from 'antd';
import user_store from '@store/User/UserList/UserStore';
import change_agent_store from '@store/Agent/ChangeAgentStore';

import {form_item_size} from '@common/theme';

const FormItem = Form.Item;

@Form.create()
@observer
class ChangeAgentModal extends React.Component {

    formItemLayout = {
        labelCol: {
            xs: {span: 12},
            sm: {span: 12},
        },
        wrapperCol: {
            xs: {span: 12, offset: 0},
            sm: {span: 12, offset: 0},
        },
        //不需要提示框
        style: {
            marginBottom: 0,
            textAlign: 'left'
        }
    };

    formItemFullLayout = {
        labelCol: {
            xs: {span: 0},
            sm: {span: 0},
        },
        wrapperCol: {
            xs: {span: 24},
            sm: {span: 24},
        },
    };

    @observable
    submitting = false;

    @observable
    password_input_type = 'password';

    @action
    togglePasswordInputType = () => {
        this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password';
    };

    constructor() {
        super();
        this.state = {someKey: 'someValue'};
    }

    @action
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (error, values) => {
            console.log('validateFields: ', values);
            if (!error) {
                console.log(values);
                let temp_value = {
                    ...values
                };
                // console.log(temp_value);
                runInAction(() => {
                    this.submitting = true;
                })
                let result = await change_agent_store.moveProxyRelation(values);
                runInAction(() => {
                    this.submitting = false;
                })

                if (result.success) {
                    message.success(`代理 ${change_agent_store.record.pet_name} 成功转移到代理 ${values.nickName}！`, 3);
                    // 重置编辑表单
                    this.props.form.resetFields();
                    // 关闭编辑弹出层
                    change_agent_store.closeModal();
                    // 重新拉数据
                    user_store.reloadDatas();
                } else {
                    message.error(`代理 ${change_agent_store.record.nickName} 转移失败！${result.error.error_data}`, 3);
                }

                return;
            }
        })
    }

    render() {
        let {getFieldDecorator} = this.props.form;

        let input_style = {
            width: '80px',
            textAlign: 'center'
        };

        return (
            <Modal
                width={'300px'}
                visible={change_agent_store.is_modal_show}
                // visible={true}
                title={(
                    <div
                        style={{
                            textAlign: 'center'
                        }}>
            <span>
              转移代理
            </span>
                    </div>
                )}
                onCancel={() => {
                    this.props.form.resetFields();
                    change_agent_store.closeModal();
                }}
                footer={null}>
                <Form>
                    <FormItem
                        style={{
                            fontSize: '12px',
                            color: 'black',
                            marginBottom: '0px'
                        }}>
                        <span>将</span>
                        <span style={{
                            fontSize: '15px',
                            fontWeight: '700',
                            marginLeft: '5px',
                            marginRight: '5px',
                        }}>{change_agent_store.record.pet_name}</span>
                        <span>转给其他代理</span>
                    </FormItem>
                    <FormItem
                        {...this.formItemFullLayout}>
                        {
                            getFieldDecorator('nickName', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入代理账号(手机)'
                                    }
                                ]
                            })(
                                <Input
                                    placeholder='请输入代理账号(手机)'
                                    size={form_item_size}
                                />
                            )
                        }
                    </FormItem>
                    <FormItem
                        {...this.formItemFullLayout}
                    >
                        {
                            getFieldDecorator('pwd', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入密码'
                                    }
                                ]
                            })(
                                <Input
                                    placeholder='请输入密码'
                                    size={form_item_size}
                                    type={this.password_input_type}
                                    addonAfter={
                                        <Icon size={form_item_size} type="eye" onClick={this.togglePasswordInputType}/>
                                    }
                                />
                            )
                        }
                    </FormItem>
                    <FormItem
                        {...this.formItemFullLayout}
                    >
                        <Button
                            block
                            type="primary"
                            onClick={this.handleSubmit}
                            loading={this.submitting}>
                            转移
                        </Button>
                    </FormItem>
                </Form>
            </Modal>
        );
    }

    componentDidMount() {
        this.setState({someKey: 'otherValue'});
    }
}

export default ChangeAgentModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/AgentList/ChangeAgent/ChangeAgentModal.jsx